
export const BookingTypeOptions = [
    { value: 0, label: "On Request" },
    { value: 1, label: "Live Book" },
    { value: 2, label: "Ticket Only" }
]
export enum BookingType {
    OnRequest, LiveBook, TicketOnly
}